export const WELCOME_DOCTOR_MODAL_Z_INDEX = 5000
export const RELEASE_NOTES_MODAL_Z_INDEX = 4000
export const ANNOUNCEMENTS_MODAL_Z_INDEX = 3000
